import { AppParagraph, AppSegment } from 'client/ui-building-blocks'
import { Theme } from 'client/utils'

type Props = {
  theme: Theme
}

const ParagraphPreview = ({ theme }: Props) => {
  return (
    <>
      <AppSegment headerProps={{ text: 'Size', marginBottom: 'small' }}>
        <AppParagraph
          text={'This is a small size text. '.repeat(25)}
          size="small"
          marginBottom="xsmall"
        />
        <AppParagraph
          text={'This is a medium size text. '.repeat(25)}
          size="medium"
          marginBottom="xsmall"
        />
        <AppParagraph
          text={'This is a large size text. '.repeat(25)}
          size="large"
          marginBottom="xsmall"
        />
        <AppParagraph
          text={'This is an extra large size text. '.repeat(15)}
          size="xlarge"
          marginBottom="xsmall"
        />
        <AppParagraph
          text={'This is a double extra large size text. '.repeat(5)}
          size="xxlarge"
          centered
        />
      </AppSegment>
      <AppSegment headerProps={{ text: 'Loading', marginBottom: 'small' }}>
        <AppParagraph
          text="Paragraph text"
          size="small"
          loading
          marginBottom="xsmall"
          theme={theme}
        />
        <AppParagraph
          text="Paragraph text"
          size="medium"
          loading
          marginBottom="xsmall"
          theme={theme}
        />
        <AppParagraph
          text="Paragraph text"
          size="large"
          loading
          marginBottom="xsmall"
          theme={theme}
        />
        <AppParagraph
          text="Paragraph text"
          size="xlarge"
          loading
          marginBottom="xsmall"
          theme={theme}
        />
        <AppParagraph text="Paragraph text" size="xxlarge" loading theme={theme} />
      </AppSegment>
    </>
  )
}

export default ParagraphPreview
